module.exports = {
	"data": [
		{
			"name": "Lisk",
			"url": "https://lisk.io/",
			"image": "/lisk-dark.jpg",
			"description": [
				"Hired by Lightcurve, I am currently a student worker of Lisk.",
				"Based on its own Blockchain network and token LSK, Lisk enables developers to build applications and deploy their own side-chain linked to the Lisk network, including a custom token.",
				"Thanks to the scalability and flexibility of side-chains, developers can implement and customize their Blockchain applications entirely."
			]
		},
		{
			"name": "Memento Preis",
			"url": "http://www.memento-preis.de/",
			"description": [
				"Die Seite des Memento-Preises für vernachlässigte Krankheiten - Redesign der Website im November 2017 war mein erstes FreelanceProjekt"
			],
			"image": "/landingpage.png"
		},
		{
			"name": "Beuth Hochschule",
			"url": "https://beuth-hochschule.de",
			"description": [
				"My awesome university! :-)"
			],
			"image": "/beuth.png"
		},
		{
			"name": "Smart Learning im Handwerk",
			"url": "https://projekt.beuth-hochschule.de/smartlearning/",
			"description": [
				"A project I worked on.",
				" The project « Smart Learning – digital media in vocational training » (SLHw) is funded by the German Ministry of Education and Research.",
				"The aim of this project is to develop a new concept for vocational training. Multimedia learning objects will be created and stored in a novel repository.",
				"Learners are assisted by an innovative learning companion app and get personalized learning recommendations based on their learning need.",
				"A Learning Analytics module helps teachers to get an overview of students’ progress and so be aware of possible weaknesses. "
			]
		},
		{
			"name": "oParl",
			"url": "https://oparl.org/",
			"description": [
				"Ein interessantes Projekt, was einen Standard für die offenen Daten aus Ratsinformations-Systemen entwickelt. Das kann imho in Zukunft sehr die Transparenz von politischer Arbeit erhöhen"
			]
		},
		{
			"name": "Fairmondo",
			"url": "https://fairmondo.de",
			"description": [
				"A project I cofounded back in december 2012",
				"Fairnopoly is a social startup located in Berlin: Too often, economy works according to the principles of a famous board game: Participants try to make as much profit as possible at the expense of others. At Fairnopoly we turn to the game upside down: Fairnopoly is an online marketplace organized as a cooperative where every stakeholder can own a share and have a saying.",
				"There are three main reasons for the 'fair' in Fairnopoly:",
				"1) A fair business model – the 'cooperative 2.0'",
				"2) The promotion of responsible consumption",
				"3) A contribution to the fight against corruption",
				"Fairnopoly is an Open Source project (using the GPLv3)."
			],
			"image": "/fairmondo.jpg"
		},
		{
			"name": "Sprungfedergirls' Blog",
			"url": "https://sprungfedergirl.wordpress.com/",
			"description": [
				"supertoller Blog :)"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/links.json
// module id = 341
// module chunks = 0